/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cross-bold': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" d="M13 1L1 13m12 0L1 1" _stroke="#C09C5E" stroke-width="2" stroke-linecap="round"/>'
  }
})
